<template>
  <div class="agreement-input">
    <div class="form-group">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 control-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <div class="radio">
          <label>
            <input type="radio" value="1"
              :name="options.name"
              :checked="value"
              @change="validate($event.target.value)"/>
              <span v-html="options.agree"></span>
          </label>
        </div>
        <div class="radio">
          <label>
            <input type="radio" value="0"
            :name="options.name"
            :checked="!value"
            @change="validate($event.target.value)">
            <span v-html="options.disagree"></span>
          </label>
        </div>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'AgreementInput',
  props: {
    value: {
      type: Boolean
    },
    options: {
      type: Object,
      default () {
        return {
          name: '',
          label: '',
          required: false
        }
      }
    }
  },
  data () {
    return {
      isValid: false,
      isDirty: false
    }
  },
  computed: {
    validationClass,
    validationMessage,
    validationIcon
  },
  methods: {
    validate (val = this.value) {
      if (!isNaN(parseInt(val))) {
        val = Boolean(parseInt(val))
      }
      this.$emit('input', val)
      this.isDirty = true
      this.isValid = val
      if (!this.options.required) {
        this.isValid = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/AgreementInput.vue